import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-4" }
const _hoisted_3 = { class: "field col-12 lg:col-4" }
const _hoisted_4 = { class: "field col-12 lg:col-4 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("utilityItemCode.oldCode")), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.oldCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldCode) = $event)),
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("utilityItemCode.newCode")), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.newCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newCode) = $event)),
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.run'),
          icon: "pi pi-bolt",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ])
    ])
  ], 32))
}